<template>
  <v-app :style="`background: ${this.blender()}`">
    <v-main>
      <v-row class="mt-4">
        <v-col align="center">
          <v-img class="rounded-circle" max-width="96" max-height="96"
                 src="https://d1fdloi71mui9q.cloudfront.net/kTy7k6iTtG73wAmJw8Sr_9RtjDcU3l2rbjW4Y"/>
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col>
          <span class="font-weight-bold white--text">{{ $t('home.title') }}</span>
        </v-col>
      </v-row>
      <router-view v-slot="{ Component }">
        <transition name="fade">
          <component :is="Component"/>
        </transition>
      </router-view>
    </v-main>
  </v-app>
</template>
<script>
export default {
  name: 'App',
  data: () => ({}),
  methods: {
    randum(max) { //随机数
      return Math.round(Math.random() * max);
    },
    hexify(x) { //转换16进制
      return ('0' + parseInt(x).toString(16)).slice(-2);
    },
    randex() { //随机16进制色彩值
      return '#' + this.hexify(this.randum(255)) + this.hexify(this.randum(255)) + this.hexify(this.randum(255));
    },
    blender() { //随机渐变
      // if (Math.round(Math.random())) {
      //   return 'radial-gradient(circle at ' + this.randum(100) + '% ' + this.randum(100) + '%, ' + this.randex() + ', ' + this.randex() + ')';
      // } else {
      return 'linear-gradient(' + this.randum(360) + 'deg, ' + this.randex() + ', ' + this.randex() + ')';
      // }
    }
  },
  mounted() {

  }
};
</script>
